import * as React from 'react';
import { ActionButtons, type ActionButtonProps } from './dialog-action-buttons';
import {
  DialogBase as Dialog,
  type DialogBaseProps,
  type DialogOptionalProps,
} from './dialog.base';
import cx from 'classnames';

export type ActionDialogProps = React.PropsWithChildren<
  DialogBaseProps & ActionButtonProps & DialogOptionalProps
>;

/**
 * A dialog with two buttons for the user to take an action to cancel or accept.
 */
export const ActionDialog = ({
  buttonOptions,
  onCancel,
  onConfirm,
  onDismiss,
  onReset,
  shouldStackButtons,
  dialogClassName,
  ...dialogProps
}: ActionDialogProps) => {
  const dialogRef = React.useRef<React.ComponentRef<'div'>>(null);

  const handleCancel = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    onCancel?.(event);
  };

  const handleConfirm = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    onConfirm?.(event);
  };

  const bottomContent = (
    <ActionButtons
      buttonOptions={buttonOptions}
      onReset={onReset}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      shouldStackButtons={shouldStackButtons}
    />
  );
  return (
    <Dialog
      {...dialogProps}
      onDismiss={onDismiss}
      bottomContent={bottomContent}
      ref={dialogRef}
      dialogClassName={cx('scroll-pb-32', dialogClassName)}
    />
  );
};
